/**
 * BackLink (§7.M4) — the shared "‹ ListName" top-bar back pattern.
 *
 * The Divergence-Memo/preview back model: a single top-bar text button that
 * REPLACES the list title on any detail/review surface (‹ glyph + the list
 * name), min 44px touch target, NO bottom Close/Back button anywhere. The
 * generic component so DailyLog (M4), the Master List detail (M5), the
 * Decision Detail (M6), and the Report detail (M7) all present the same
 * affordance — each caller supplies its own `testid` (the preview names them
 * per-surface: `save-screen-back`, `decision-detail-close`, …) and its own
 * list label.
 */
export interface BackLinkProps {
  /** The list this link returns to, e.g. "Daily logs" / "Master List". */
  label: string;
  onBack: () => void;
  /** Per-surface testid (the preview uses a different one per surface). */
  testid?: string;
}

export function BackLink({ label, onBack, testid }: BackLinkProps) {
  return (
    <button
      type="button"
      class="list-back"
      data-testid={testid}
      aria-label={`Back to ${label}`}
      onClick={onBack}
      style="align-self:flex-start;background:none;border:none;padding:0;min-height:44px;font-family:inherit;font-size:17px;font-weight:600;color:var(--mark-text-primary);cursor:pointer"
    >
      {"‹  "}
      {label}
    </button>
  );
}
